const angular = require('angular');

module.exports = function restAngularConfiguration(RestangularProvider, $windowProvider) {

    //We're still configuring providers so we can't inject $window directly, we have to use the provider
    const $win = $windowProvider.$get();

    RestangularProvider.setBaseUrl($win.config.apiUrl);

    RestangularProvider.setDefaultHttpFields({ withCredentials: true });

    RestangularProvider.setRestangularFields({ id: 'Stockcode' });

    RestangularProvider.addResponseInterceptor(function (response) {
        const newResponse = response;
        if (angular.isArray(response)) {
            newResponse.rawResponse = []; //add this so you don't get an error!
            angular.forEach(newResponse, function (value, key) {
                newResponse.rawResponse[key] = angular.copy(value);
            });
        }
        return newResponse;
    });
};



/** WEBPACK FOOTER **
 ** ./wowapp/src/shop/configuration/restangular.js
 **/